import Zebra from './Zebra'

export default Zebra
